module.exports = __webpack_public_path__ + "img/logo.e70d9d8c.png";